/**
 * Widget compacto de Cobertura Técnica no corpo do Dashboard (GUPM-199) — fiel ao
 * `buildTechCoverageCompact` do V8: verde = horário administrativo (RT Foscentro
 * no plantão), laranja = sobreaviso (RT JF Brasil). Clicável → modal com os
 * contatos do banco. O telefone NÃO é hardcoded (o V8 hardcoda) — aparece no modal,
 * vindo de `contacts`. Alinhado à direita, no topo da página (como no protótipo).
 */
import { useState } from 'react';
import { isBusinessHours } from '@/domain/cobertura';
import { CoberturaTecnicaModal } from './CoberturaTecnicaModal';

export function TechCoverageCard() {
  const [open, setOpen] = useState(false);
  const ativa = isBusinessHours();

  return (
    <div className="flex justify-end mb-3">
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Ver cobertura técnica — abrir contatos do plantão"
        className={`flex items-center gap-2 rounded-[10px] border px-3 py-1.5 text-left transition hover:brightness-110 max-w-[340px] ${
          ativa ? 'border-level-normal/40 bg-level-normal/10' : 'border-level-alerta/40 bg-level-alerta/10'
        }`}
      >
        <span
          className={`w-2 h-2 rounded-full flex-shrink-0 ${ativa ? 'bg-level-normal' : 'bg-level-alerta'}`}
          aria-hidden
        />
        <span className="min-w-0">
          <span
            className={`block text-[11px] font-bold leading-tight ${
              ativa ? 'text-level-normal' : 'text-level-alerta'
            }`}
          >
            {ativa ? 'Cobertura técnica ativa' : 'Fora do horário — RT JFB sobreaviso'}
          </span>
          <span className="block text-[10px] text-jf-muted leading-tight truncate">
            {ativa ? 'RT Foscentro · 08h–18h dias úteis' : 'Em anomalia, siga o protocolo TARP'}
          </span>
        </span>
        <span className="flex-shrink-0 text-jf-muted text-sm" aria-hidden>
          ⓘ
        </span>
      </button>
      {open && <CoberturaTecnicaModal onClose={() => setOpen(false)} />}
    </div>
  );
}
